import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from 'components/common';

const ProductGallerySkeleton = ({
  width = 1188,
  row = 2,
  column = 3,
  padding = 20,
  borderRadius = 0,
  ...props
}) => {
  const list = [];

  let height;

  for (let i = 1; i <= row; i++) {
    for (let j = 0; j < column; j++) {
      const itemWidth = (width - padding * (column + 1)) / column;

      const x = j * (itemWidth + padding);

      const height1 = itemWidth;

      const height2 = 20;

      const height3 = 20;

      const space =
        height1 + (padding / 2 + height2) + height3 + padding * 4;

      const y1 = space * (i - 1);

      const y2 = y1 + padding + height1;

      const y3 = y2 + padding / 2 + height2;

      list.push(
        <>
          <rect
            x={x}
            y={y1}
            rx={borderRadius}
            ry={borderRadius}
            width={itemWidth}
            height={height1}
          />
          <rect
            x={x}
            y={y2}
            rx={0}
            ry={0}
            width={itemWidth}
            height={height2}
          />
          <rect
            x={x}
            y={y3}
            rx={0}
            ry={0}
            width={itemWidth * 0.6}
            height={height3}
          />
        </>,
      );

      if (i === row) {
        height = y3 + height3;
      }
    }
  }

  return (
    <Skeleton
      type="custom"
      viewBox={`0 0 ${width} ${height}`}
      width="100%"
      height={height}
      {...props}
    >
      {list}
    </Skeleton>
  );
};

ProductGallerySkeleton.propTypes = {};

export default ProductGallerySkeleton;
